import { of, combineLatest } from 'rxjs'
import { takeUntil, concatMap, map } from 'rxjs/operators'
import { values, intersection, castArray, map as _map } from 'libraries/lodash'

import RESPONSES, { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import { Controller } from 'front-end-core/core/Router'
import getUrl from 'front-end-core/core/url'
import { expand } from 'front-end-core/services/ShortenerService'

import { MW_DEAL_COMPARE } from 'constants/controllers'
import Header from 'components/dealwatch/header'
import Main from 'redux/containers/pages/mwdealcompare/DealCompareContainer'
import Left from 'redux/containers/pages/mwdealcompare/FilterContainer'
import { getComparableParameters, requestDeals, requestEventConfiguration } from 'services/DealwatchService'
import ResponseConsumer from 'pages/share/Main'

const responses = values(RESPONSES)

const responseObject = (statusCode = RESPONSE_PENDING) => ({
  deals: [statusCode],
  comparableParams: statusCode
})

export default new Controller({
  name: MW_DEAL_COMPARE,
  route: ':aol/markets/dealcompare/:short',
  controller (Router, { url: pageId, pageView, params: { aol, short }, query }, render) {
    expand(short)
      .pipe(
        takeUntil(Router),
        concatMap(response => {
          if (responses.includes(response)) {
            return of(response === RESPONSE_PENDING
              ? responseObject()
              : responseObject(response)
            )
          }
          const { dealIds, dealType } = JSON.parse(response)
          const deals = requestDeals(dealIds)
          const documentConfiguration = requestEventConfiguration({ type: dealType })

          return combineLatest([deals, documentConfiguration]).pipe(
            map(([deals, documentConfiguration]) => ({ deals, documentConfiguration }))
          )
        }),
        map(({ deals, documentConfiguration }) => {
          if (deals.includes(RESPONSE_PENDING) || documentConfiguration === RESPONSE_PENDING) {
            return responseObject()
          } else {
            return {
              deals,
              comparableParams: getComparableParameters(deals, documentConfiguration)
            }
          }
        })
      )
      .subscribe(({ comparableParams, deals }) => {
        const layoutProps = {
          aol,
          pageId: getUrl(MW_DEAL_COMPARE),
          pageView,
          searchType: 'dealwatch',
          className: 'dealwatch'
        }

        const successfulResponses = !(responses.includes(comparableParams) ||
          intersection(responses, deals).length
        )

        if (!successfulResponses) {
          render(
            { Main: ResponseConsumer, Header },
            { responses: [comparableParams, ...deals] },
            layoutProps
          )
        } else {
          const show = !query.show
            ? []
            : castArray(query.show)
          const compareParams = intersection(
            _map(comparableParams, ({ name }) => name),
            show
          )

          render(
            { Main, Left, Header },
            { comparableParams, compareParams, deals, query, short, controller: MW_DEAL_COMPARE },
            layoutProps
          )
        }
      })
    return pageId
  }
})
